import axios, { AxiosPromise } from 'axios';

import { RevisionDiff } from '../type';

export const getDiffFromEventoUsuario = (
  idEvento: string,
  externo: boolean
): AxiosPromise<RevisionDiff[]> =>
  axios.get(
    `/painel-api/api/eventos/usuarios/${idEvento}/diff?external=${externo}`
  );
